import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
@Injectable()
export abstract class AbstractService{

	constructor(protected http: HttpClient, protected router: Router) {}

	private shouldShowErrorMessage(error: HttpErrorResponse): boolean{
		let show = true;
		if(error.status === 401) show = false;
		return show;
	}

	protected handleError(operations?: string, ignore: boolean = false): (HttpErrorResponse) => Observable<any>{
		return (errorResponse: HttpErrorResponse) => {
			if(ignore) return throwError(errorResponse);
			this.showErrorMessageFromResponse(errorResponse);
			
			return throwError(errorResponse);
		};
	}

	public getFirstValidationError(errors): string{
		for (const errorKey in errors) {
			if (!Object.prototype.hasOwnProperty.call(errors, errorKey)) continue;
			const element = errors[errorKey];
			if(typeof(element) === 'string' ) return element;
			if(element instanceof Array && element.length > 0 && typeof(element[0]) === 'string') return element[0];
		}
		return null;
	}

	public showErrorMessageFromResponse(response: HttpErrorResponse): void{
		if(!response) return;
		let message = response.message;
		console.log(response, this.shouldShowErrorMessage(response), response.error);
		if(this.shouldShowErrorMessage(response)){
			if(response.status === 422){
				const firstValidationError = this.getFirstValidationError(response.error && response.error.errors);
				message = firstValidationError ? firstValidationError : 'Dati non validi.';
			} else if (response.status === 404){
				this.router.navigate(['/notfound']);
			} else if(response.error && response.error.message){
				message = response.error.message;
			}
		}else{
			message = null;
		}
	}
}
